import { COGNITO_LOGOUT_URI, COGNITO_REDIRECT_URI } from 'config'
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

export const userManager = new UserManager({
  authority: process.env.REACT_APP_COGNITO_AUTHORITY!,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID!,
  redirect_uri: COGNITO_REDIRECT_URI,
  response_type: process.env.REACT_APP_COGNITO_RESPONSE_TYPE,
  scope: process.env.REACT_APP_COGNITO_SCOPE,
  post_logout_redirect_uri: COGNITO_LOGOUT_URI,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  metadata: {
    authorization_endpoint: process.env.REACT_APP_COGNITO_AUTHORIZATION_ENDPOINT,
    token_endpoint: process.env.REACT_APP_COGNITO_TOKEN_ENDPOINT,
    userinfo_endpoint: process.env.REACT_APP_COGNITO_USERINFO_ENDPOINT,
    end_session_endpoint: process.env.REACT_APP_COGNITO_END_SESSION_ENDPOINT,
    jwks_uri: process.env.REACT_APP_COGNITO_JWKS_URI,
    issuer: process.env.REACT_APP_COGNITO_ISSUER,
  },
})
